import { render, staticRenderFns } from "./realQuestion.vue?vue&type=template&id=29b16f5f&scoped=true&"
import script from "./realQuestion.vue?vue&type=script&lang=js&"
export * from "./realQuestion.vue?vue&type=script&lang=js&"
import style0 from "./realQuestion.vue?vue&type=style&index=0&id=29b16f5f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b16f5f",
  null
  
)

export default component.exports